import { CASTracker } from '../../cimsPage/instances/cas'
import { ConcreteTestSets } from '../../cimsPage/instances/concrete'
import { DSLog } from '../../cimsPage/instances/ds'
import { FDCTracker } from '../../cimsPage/instances/fdc'
import { CustomFieldEntityItem } from './CustomFieldEntityItem'

export const DS = new CustomFieldEntityItem({
  id: 'a9aec3b2-57dc-4bc4-bb86-3e604f48cde9',
  type: 'Design Submittal',
  classType: 'DesignSubmittal',
  key: 'id',
  label: 'sharePointFolderName',
  page: DSLog,
})
export const CAS = new CustomFieldEntityItem({
  id: '2b627113-9cdc-4b43-9878-c60e1a29b274',
  type: 'Construction & Admin Submittal',
  classType: 'ConstructionAdminSubmittal',
  key: 'id',
  label: 'sharePointFolderName',
  page: CASTracker,
})
export const FDC = new CustomFieldEntityItem({
  id: 'a5853a67-7ad1-4606-b703-1c099572e836',
  type: 'Field Design Change',
  classType: 'FieldDesignChange',
  key: 'id',
  label: 'formattedNumber',
  page: FDCTracker,
})
export const CTS = new CustomFieldEntityItem({
  id: '51fd9d74-a54d-43d6-a615-048731aaa74a',
  type: 'Concrete Test Set',
  classType: 'ConcreteTestSet',
  label: 'testSetId',
  key: 'globalId',
  page: ConcreteTestSets,
})
